import { Skill } from './Skill';

export interface SkillAncestries {
  id: string;
  ancestorSkill: Skill;
  skillRelevance: {
    id: string;
    name?: string;
  };
}

export enum SkillAncestriesId {
  LOW = 'SkillRelevanceNode:1',
  MEDIUM = 'SkillRelevanceNode:2',
  HIGH = 'SkillRelevanceNode:3',
}
